export enum NodeClassNames {
	LINK = 'editor-link',
}
